// Общие данные кнопочных рядов панели настроек. Отдельно от SegmentedRow.tsx:
// файл с компонентом не должен экспортировать ничего кроме компонентов
// (react-refresh/only-export-components).
import { AlignCenter, AlignLeft } from 'lucide-react'
import type { LucideIcon } from 'lucide-react'
import { cn } from '@teach/ui'
import { messagesNow } from '@/i18n'
import { messages } from './messages'

export interface SegmentedOption<V extends string> {
  value: V
  label?: string
  icon?: LucideIcon
  title?: string
}

/** Класс «выбранной таблетки» — переиспользуется там, где нужен тот же вид,
 *  но не сам ряд: сетка в две колонки, независимые тогглы форматирования. */
export const segmentedButtonClass = (active: boolean): string =>
  cn(
    'rounded-lg transition-colors',
    active ? 'bg-primary text-primary-foreground' : 'bg-muted hover:bg-muted/80',
  )

/** Порт ref align-selector: left/center с иконками — байт-в-байт одинаков
 *  в Button/Heading/TextSettings, поэтому один источник истины. */
export const ALIGN_OPTIONS: Array<SegmentedOption<'left' | 'center'>> = [
  // Подпись — геттер: читается на рендере, на текущем языке интерфейса.
  {
    value: 'left',
    icon: AlignLeft,
    get title() {
      return messagesNow(messages).alignLeft
    },
  },
  {
    value: 'center',
    icon: AlignCenter,
    get title() {
      return messagesNow(messages).alignCenter
    },
  },
]
